import React, { useState} from "react";
import { Button, Table, Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import { v4 } from "uuid";
import jsDig from "utils/jsDig.js";
export default function ConversionActionIds(props) {
  const [conversionActionsEnabled, setConversionActionsEnabled] = useState(
    props.conversionActionsEnabled !== undefined ? props.conversionActionsEnabled : false
  );
  const [conversionActions, setConversionActions] = useState(
    props.conversionActions ? props.conversionActions : [{ conversion_type: "exclusive", name: "", conversion_id: "" }]
  );
  const handleDelete = (targetIndex) => {
    let newActions = conversionActions;
    newActions.splice(targetIndex, 1);
    setConversionActions([...newActions]);
    props.setConversionActions && props.setConversionActions([...newActions]);
  };

  const handleChange = (targetIndex, property, value) => {
    let newActions = conversionActions.map((action, index) => {
      let newAction = action;
      if (index == targetIndex) {
        newAction[property] = value;
      }
      return newAction;
    });
    setConversionActions(newActions);
    props.setConversionActions ? props.setConversionActions([...newActions]) : null;
  };
  return (
    <>
      <div>
        <div style={{ marginLeft: "3px" }}>
          <CustomFormCheck
            id={`conversion-actions-enabled-${v4()}`}
            name={`${props.fieldName}[enabled]`}
            label={props.option ? `Enable ${props.option}` : "Enable"}
            checked={props.onChange ? props.conversionActionsEnabled : conversionActionsEnabled}
            sendUncheckedValue
            onChange={
              props.onChange
                ? props.onChange
                : () => {
                  setConversionActionsEnabled(!conversionActionsEnabled);
                }
            }
          />
        </div>
        <div className={props.conversionActionsEnabled === true ? "ml-0 table-responsive mt-3 pb-3" : "display-hidden"}>
          <Table style={{ margin: "0px" }} className="ml-0">
            <tbody>
              {props.option ? (
                <tr>
                  <td style={{ minWidth: "126px" }} className="pl-0"></td>
                  <td style={{ minWidth: "180px" }}>
                    <p className="f12 pl-2 primary nunito-regular">Label</p>{" "}
                  </td>
                  <td style={{ minWidth: "180px" }}>
                    <p className="f12 pl-2 primary nunito-regular">ID</p>
                  </td>
                  <td></td>
                </tr>
              ) : undefined}
              {conversionActions.map((conversionAction, index) => {
                return (
                  <tr key={index}>
                    <td style={{ width: "126px" }} className="pl-0">
                      <input
                        hidden
                        name={`${props.fieldName}[${index}][id]`}
                        value={jsDig(["id"], conversionAction) ? jsDig(["id"], conversionAction) : undefined}
                        readOnly
                      />
                      <Form.Control
                        className="primary"
                        style={{ width: "126px" }}
                        as="select"
                        size="sm"
                        name={`${props.fieldName}[${index}][conversion_type]`}
                        value={jsDig(["conversion_type"], conversionAction) ? jsDig(["conversion_type"], conversionAction) : "exclusive"}
                        onChange={(e) => handleChange(index, "conversion_type", e.target.value)}
                        readOnly={props.conversionActionsEnabled !== undefined ? !props.conversionActionsEnabled : !conversionActionsEnabled}>
                        <option value="exclusive">Exclude</option>
                        <option value="inclusive">Include</option>
                      </Form.Control>
                    </td>
                    <td style={{ width: "180px" }}>
                      <Form.Control
                        size="sm"
                        className="conversion-actions-label"
                        placeholder="Label"
                        name={`${props.fieldName}[${index}][name]`}
                        value={jsDig(["name"], conversionAction) ? jsDig(["name"], conversionAction) : ""}
                        onChange={(e) => handleChange(index, "name", e.target.value)}
                        readOnly={props.conversionActionsEnabled !== undefined ? !props.conversionActionsEnabled : !conversionActionsEnabled}
                      />
                    </td>
                    <td style={{ width: "180px" }}>
                      <Form.Control
                        size="sm"
                        className="conversion-actions-id"
                        placeholder="ID"
                        name={`${props.fieldName}[${index}][conversion_id]`}
                        value={jsDig(["conversion_id"], conversionAction) ? jsDig(["conversion_id"], conversionAction) : ""}
                        onChange={(e) => handleChange(index, "conversion_id", e.target.value)}
                        readOnly={props.conversionActionsEnabled !== undefined ? !props.conversionActionsEnabled : !conversionActionsEnabled}
                      />
                    </td>
                    {(index >= 0 && conversionActions.length > 0) ? (
                      <td onClick={() => handleDelete(index)}>
                        <i className="fas fa-minus-circle"></i>
                      </td>
                    ) : (
                      <td></td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <div className={props.conversionActionsEnabled === true ? "text-center text-md-left" : "display-hidden"}>
          <Button
            style={{
              marginLeft: "3px",
              paddingLeft: "35px",
              paddingRight: "35px",
            }}
            className="my-3 btn-sm"
            variant="success"
            onClick={() => {
              setConversionActions([...conversionActions, { conversion_type: "exclusive", name: "", conversion_id: "" }]);
              props.setConversionActions
                ? props.setConversionActions([...conversionActions, { conversion_type: "exclusive", name: "", conversion_id: "" }])
                : null;
            }}>
            + Add
          </Button>
          {props.cg &&
            <p>Conversion actions defined here are the only ones that will be used for this campaign group</p>
          }
        </div>
      </div>
    </>
  );
}
